var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"advertise-default"}},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',[_vm._v("广告管理")]),_c('el-breadcrumb-item',[_vm._v("默认广告")])],1),_c('adList',{attrs:{"advtisementType":_vm.advtisementType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }